import { HabitSchedule, Timestamp } from '@griply/types';
import { getScheduleByDate } from '@griply/utils';
import { isSameDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';

export const usePlannedOccurrenceForDate = (
  schedules: HabitSchedule[] | undefined | null,
  date: Timestamp,
) => {
  const today = useToday();

  return useMemo(() => {
    const schedule = getScheduleByDate(schedules, { date, today });

    if (!schedule) {
      return;
    }

    return schedule.plannedOccurrences?.find(({ date: plannedDate }) =>
      isSameDay(plannedDate, date),
    );
  }, [date, schedules, today]);
};
